// removed by extract-text-webpack-plugin
module.exports = {"access-back-office-title":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOffice-__AccessBackOffice___2dRTh","access-back-office-description":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOffice-__AccessBackOffice___rnYlX","partial-checked":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOffice-__AccessBackOffice___1hZzV"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessBackOffice/AccessBackOffice.css
// module id = 2329
// module chunks = 0